import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useIntakes } from '../../hooks/useIntakes';
import IntakeForm from '../../components/forms/IntakeForm';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const IntakeEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { intakes, updateIntake } = useIntakes();
  const [loading, setLoading] = useState(false);
  const [intake, setIntake] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    // Find the intake by ID
    const foundIntake = intakes.find(i => i.id === id);
    if (foundIntake) {
      setIntake(foundIntake);
    } else if (intakes.length > 0) {
      // If intakes are loaded but not found
      setNotFound(true);
    }
  }, [id, intakes]);

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const result = await updateIntake(id, formData);
      if (result.success) {
        alert('Intake updated successfully!');
        navigate('/intakes');
      } else {
        alert(result.error || 'Failed to update intake');
      }
    } catch (error) {
      alert('An unexpected error occurred');
      console.error('Error updating intake:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/intakes');
  };

  if (notFound) {
    return (
      <div className="space-y-6">
        <div className="flex items-center space-x-4">
          <Button 
            variant="outline" 
            onClick={handleCancel}
            className="flex items-center"
          >
            <ArrowLeftIcon className="h-5 w-5 mr-1" />
            Back
          </Button>
          <h1 className="text-xl font-bold text-gray-900">Intake Not Found</h1>
        </div>
        <Card>
          <div className="py-8 text-center">
            <p className="text-gray-500">The intake you are trying to edit does not exist.</p>
          </div>
        </Card>
      </div>
    );
  }

  if (!intake) {
    return (
      <div className="space-y-6">
        <div className="flex items-center space-x-4">
          <Button 
            variant="outline" 
            onClick={handleCancel}
            className="flex items-center"
          >
            <ArrowLeftIcon className="h-5 w-5 mr-1" />
            Back
          </Button>
          <h1 className="text-xl font-bold text-gray-900">Edit Intake</h1>
        </div>
        <Card>
          <div className="py-8 text-center">
            <p className="text-gray-500">Loading intake data...</p>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <Button 
          variant="outline" 
          onClick={handleCancel}
          className="flex items-center"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-1" />
          Back
        </Button>
        <h1 className="text-xl font-bold text-gray-900">Edit Intake</h1>
      </div>
      
      <Card>
        <IntakeForm
          initialData={intake}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          loading={loading}
        />
      </Card>
    </div>
  );
};

export default IntakeEdit;